/*
 * @Author: sunlvte 8403981+sunlvte@user.noreply.gitee.com
 * @Date: 2023-01-12 13:51:16
 * @LastEditors: sunlvte 8403981+sunlvte@user.noreply.gitee.com
 * @LastEditTime: 2024-11-29 17:24:44
 * @FilePath: /jl-web/src/router/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import Router from 'vue-router'
import home from '@/views/t97'



Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    },
   
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js